module.exports = __webpack_public_path__ + "img/financeiro.5a607e95.jpg";